<template>
  <div class="container" @dragover.prevent="activeDragLayer" @drop.prevent="hideDragLayer">
    <el-breadcrumb>
      <el-breadcrumb-item :to="Paths.HOMEPAGE">Trang chủ</el-breadcrumb-item>
      <el-breadcrumb-item>Tài liệu</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="d-flex flex-column">
      <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="6">
          <h2 class="heading_one">Quản lý tài liệu</h2>
        </el-col>
        <el-col :span="6" class="d-flex flex-column align-items-end">
          <el-button
            :disabled="!documentPermissions.includes(Permission.CREATE)"
            type="primary"
            @click="$refs[refs.DOCUMENT_CREATE_BUTTON].openModal()"
          >
            <FAIcon icon="fas fa-plus" color="white" />
            Tải tài liệu để kiểm tra
          </el-button>
        </el-col>
      </el-row>

      <div class="drop-layer" :class="dropLayerState" @dragleave.prevent="hideDragLayer" @drop.prevent="dropHandler">
        <div style="text-align: center; cursor: default">
          <svg
            width="12rem"
            height="12rem"
            viewBox="0 0 16 16"
            class="bi bi-file-earmark-arrow-up"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 0h5.5v1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h1V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"
            />
            <path d="M9.5 3V0L14 4.5h-3A1.5 1.5 0 0 1 9.5 3z" />
            <path
              fill-rule="evenodd"
              d="M8 12a.5.5 0 0 0 .5-.5V7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-2-2a.5.5 0 0 0-.708 0l-2 2a.5.5 0 1 0 .708.708L7.5 7.707V11.5a.5.5 0 0 0 .5.5z"
            />
          </svg>
          <h2 style="margin-top: 10px">Kéo thả tài liệu vào đây !</h2>
        </div>
      </div>
      <DocumentList ref="documentList" @addFileToListDroppedFiles="addToDroppedFile" @empty="showNewDocumentForm" />
      <DocumentCreate
        :ref="refs.DOCUMENT_CREATE_BUTTON"
        @success="reload"
        :listDroppedFiles="droppedFiles"
        @removeAllFileInDroppedList="removeAllFileInDroppedList"
      />
    </div>
  </div>
</template>

<script>
import DocumentList from '@/components/DocumentManagement/DocumentList'
import DocumentCreate from '@/components/DocumentManagement/DocumentCreate'
import { Paths } from '@/routes/paths.js'
import { mapGetters } from 'vuex'
import { AuthenticateGetter } from '@/store/modules/AuthenticateStore.js'
import { Permission } from '@/constants/DoITConstant.js'
import FAIcon from '@/components/common/FAIcon.vue'

export default {
  name: 'UserDocumentManagementView',
  components: { FAIcon, DocumentList, DocumentCreate },
  data: function () {
    return {
      documents: [],
      meta: {},
      droppedFiles: [],
      dropLayerState: 'hiden',
      documentListState: '',
      Paths,
      refs: {
        DOCUMENT_CREATE_BUTTON: 'DOCUMENT_CREATE_BUTTON',
      },
      Permission,
    }
  },
  async mounted() {},
  methods: {
    reload() {
      this.$refs.documentList.loadItems()
    },
    addToDroppedFile(files) {
      let acceptedFiles = []
      files.forEach((file) => {
        let fileType = file.name.split('.').slice(-1)[0]
        let isAccepted = fileType === 'doc' || fileType === 'docx' || fileType === 'pdf' || fileType === 'zip'
        if (isAccepted) {
          acceptedFiles.push(file)
        } else {
          this.$message({
            message: 'Tài liệu tải lên không đúng định dạng',
            type: 'error',
          })
        }
      })
      this.droppedFiles = [...this.droppedFiles, ...acceptedFiles]
    },
    removeAllFileInDroppedList() {
      this.droppedFiles = []
    },
    dropHandler(e) {
      e.preventDefault()
      e.stopPropagation()
      let filesList = Array.from(e.dataTransfer.files)
      this.addToDroppedFile(filesList)
      this.dropLayerState = 'hiden'
    },
    activeDragLayer(e) {
      this.dropLayerState = 'active'
    },
    hideDragLayer(e) {
      this.dropLayerState = 'hiden'
    },
    showNewDocumentForm() {
      if (this.documentPermissions.includes(Permission.CREATE)) {
        this.$refs[this.refs.DOCUMENT_CREATE_BUTTON].openModal()
      }
    },
  },
  computed: {
    ...mapGetters({
      documentPermissions: AuthenticateGetter.DOCUMENT_PERMISSIONS,
    }),
  },
}
</script>

<style scoped>
.drop-layer {
  display: flex;
  flex-direction: row;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  height: 70%;
  background: rgba(52, 73, 94, 0.3);
  z-index: 88888;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 10px rgb(0, 0, 0);
  border: 5px dashed rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
.hiden {
  display: none;
}
.active {
  display: flex;
}
.avoid-event {
  pointer-events: none;
  cursor: none;
}
</style>

<style></style>
